import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { ActivatedRoute , Router } from '@angular/router';
import { HOW_IT_WORKS_TEACHER_STEP1 , HOW_IT_WORKS_TEACHER_STEP2,HOW_IT_WORKS_TEACHER_STEP3,HOW_IT_WORKS_FEATURE_TEACHER,
  HOW_IT_WORKS_TEACHER_PROFILE,HOW_IT_WORKS_TEACHER_CLASSES,HOW_IT_WORKS_TEACHER_ENROLLMENT,HOW_IT_WORKS_TEACHER_CALENDER,
  HOW_IT_WORKS_TEACHER_ASSIGNMENT,HOW_IT_WORKS_TEACHER_ACCESSMENT,HOW_IT_WORKS_TEACHER_NOTICE,HOW_IT_WORKS_TEACHER_ENQUIRY,
  HOW_IT_WORKS_TEACHER_NEWJOBS,HOW_IT_WORKS_TEACHER_PUBLISH,HOW_IT_WORKS_TEACHER_DOWNLOAD_APP,LOGIN_PLAYSTORE_LINK,LOGIN_APPLE_STORE_LINK,LEARNING_MANAGEMENT_TEXT,DEMO_ENROLLMENT_TEXT,PROFILE_SETUP,
  WHY_STUDENT_APP_TEXT11,WHY_STUDENT_APP_TEXT12,WHY_STUDENT_APP_TEXT13,WHY_STUDENT_APP_TEXT14,
  WHY_STUDENT_APP_TEXT15,WHY_STUDENT_APP_TEXT16,WHY_STUDENT_APP_TEXT17,WHY_STUDENT_APP_TEXT18,WHY_STUDENT_APP_TEXT19,WHY_STUDENT_APP_TEXT20
}
 from 'src/app/constants';
 import {HOW_IT_WORKS_TEACHER_TITLE,HOW_IT_WORKS_TEACHER_KEYWORDS,HOW_IT_WORKS_TEACHER_CONTENT,HOW_IT_WORKS_TEACHER_DESC,HOW_IT_WORKS_TEACHER_DESC_CONTENT} from  'src/app/seoconstants';  
 import { Title, Meta } from '@angular/platform-browser'; 
 import { ApiService } from '../api.service';


@Component({
  selector: 'app-how-it-works-teacher',
  templateUrl: './how-it-works-teacher.component.html',
  styleUrls: ['./how-it-works-teacher.component.scss']
})
export class HowItWorksTeacherComponent implements OnInit {
  text1:string;
  text2:string;
  text3:string;
  text4:string;
  text5:string;
  text6:string;
  text7:string;
  text8:string;
  text9:string;
  text10:string;
  text11:string;
  text12:string;
  text13:string;
  text14:string;
  text15:string;
  
  text19:string;
  text20:string;
  text21:string;
  whystudentapp11:string;
  whystudentapp12:string;
  whystudentapp13:string;
  whystudentapp14:string;
  whystudentapp15:string;
  whystudentapp16:string;
  whystudentapp17:string;
  whystudentapp18:string;
  whystudentapp19:string;
  whystudentapp20:string;
  applelink:string;
  playstorelink:string;

  title:string;
  keywords:string;
  keywordcontent:string;
  desc:string;
  desccontent:string;
  

  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    private titleService: Title, private metaService: Meta) { }

  ngOnInit() {


    this.title = HOW_IT_WORKS_TEACHER_TITLE;
    this.keywords = HOW_IT_WORKS_TEACHER_KEYWORDS;
    this.keywordcontent = HOW_IT_WORKS_TEACHER_CONTENT;
    this.desc = HOW_IT_WORKS_TEACHER_DESC;
    this.desccontent = HOW_IT_WORKS_TEACHER_DESC_CONTENT;


    this.titleService.setTitle(this.title);
    this.metaService.addTags([
      {name: this.keywords, content: this.keywordcontent},
      {name: this.desc, content: this.desccontent},
      {name: 'robots', content: 'index, follow'}
    ]);

    
    this.text1 = HOW_IT_WORKS_TEACHER_STEP1;
    this.text2 = HOW_IT_WORKS_TEACHER_STEP2;
    this.text3 = HOW_IT_WORKS_TEACHER_STEP3;
    this.text4 = HOW_IT_WORKS_FEATURE_TEACHER;
    this.text5 = HOW_IT_WORKS_TEACHER_PROFILE;
    this.text6 = HOW_IT_WORKS_TEACHER_CLASSES;
    this.text7=  HOW_IT_WORKS_TEACHER_ENROLLMENT;
    this.text8 = HOW_IT_WORKS_TEACHER_CALENDER;
    this.text9 = HOW_IT_WORKS_TEACHER_ASSIGNMENT;
    this.text10 = HOW_IT_WORKS_TEACHER_ACCESSMENT;
    this.text11 = HOW_IT_WORKS_TEACHER_NOTICE;
    this.text12 = HOW_IT_WORKS_TEACHER_ENQUIRY;
    this.text13 = HOW_IT_WORKS_TEACHER_NEWJOBS;
    this.text14 = HOW_IT_WORKS_TEACHER_PUBLISH;
    this.text15 = HOW_IT_WORKS_TEACHER_DOWNLOAD_APP;
    
    this.text19 = LEARNING_MANAGEMENT_TEXT;
    this.text20 = DEMO_ENROLLMENT_TEXT;
    this.text21 = PROFILE_SETUP;

    this.whystudentapp11 = WHY_STUDENT_APP_TEXT11;
    this.whystudentapp12 = WHY_STUDENT_APP_TEXT12;
    this.whystudentapp13 = WHY_STUDENT_APP_TEXT13;
    this.whystudentapp14 = WHY_STUDENT_APP_TEXT14;
    this.whystudentapp15 = WHY_STUDENT_APP_TEXT15;
    this.whystudentapp16 = WHY_STUDENT_APP_TEXT16;
    this.whystudentapp17 = WHY_STUDENT_APP_TEXT17;
    this.whystudentapp18 = WHY_STUDENT_APP_TEXT18;
    this.whystudentapp19 = WHY_STUDENT_APP_TEXT19;
    this.whystudentapp20 = WHY_STUDENT_APP_TEXT20;
    
    this.applelink = LOGIN_APPLE_STORE_LINK;
    this.playstorelink = LOGIN_PLAYSTORE_LINK;
  }

  customOptions: OwlOptions = {
    loop: true,
    autoplay: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 2000,
    autoplaySpeed: 2000,
    autoplayTimeout: 100,
    navText: ["<img src='assets/images/aro-fnt-blk.png'>", "<img src='assets/images/aro-bk-blk.png'>"],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 1
      },
      740: {
        items: 2
      },
      940: {
        items: 4
      }
    },
    nav: true
  }



customOptionsfeature: OwlOptions = {
  loop: true,
  autoplay: true,
  mouseDrag: true,
  touchDrag: true,
  pullDrag: true,
  dots: false,
  navSpeed: 2000,
  autoplaySpeed: 2000,
  autoplayTimeout: 100,
  navText: [ "<img src='assets/images/aro-bk-blk.png'>", "<img src='assets/images/aro-fnt-blk.png'>"],
  responsive: {
    0: {
      items: 1
    },
    400: {
      items: 1
    },
    740: {
      items: 1
    },
    940: {
      items: 1
    }
  },
  nav: true
}

}


      